import { Alert } from "../Components/ui/shadcn/alert";
import React, { ReactNode, createContext, useState } from "react";

interface AlertProviderProps {
  children: ReactNode;
}
interface AlertContextProps {
  setAlertMessage: (
    newSeverity: "success" | "warning" | "error" | "info",
    newMessage: string
  ) => void;
}

export const AlertContext = createContext<AlertContextProps>(
  {} as AlertContextProps
);

export const AlertProvider: React.FC<AlertProviderProps> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [alert, setAlert] = useState<{
    message: string | null;
    severity: "success" | "warning" | "error" | "info";
  }>({ message: "Seja bem vindo!", severity: "success" });
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const setAlertMessage = (
    newSeverity: "success" | "warning" | "error" | "info",
    newMessage: string
  ) => {
    setAlert({ severity: newSeverity, message: newMessage });
    setOpen(true);
  };

  return (
    <AlertContext.Provider value={{ setAlertMessage }}>
      {children}
      {open && (
        <Alert
          onClose={handleClose}
          variant={alert.severity}
          className="w-[680px] fixed bottom-8 left-8 z-panel"
        >
          {alert.message}
        </Alert>
      )}
    </AlertContext.Provider>
  );
};
